import splunkLogger from "./splunkLogger";
import { uniqueUserId } from "./uniqueIdContext";
import * as _ from "lodash";
import { deviceDetect } from 'react-device-detect';

function createLogEntry(actionName, screenName, error, info) {
  if(!_.isEmpty(error)){
    error.config && delete error.config;
    error.response && delete error.response.config;
  }
  
  const payload = {
    application: 'PRIVACY PORTAL FRONTEND',
    user_id: uniqueUserId,
    timeStamp: new Date(),
    screen: screenName,
    action: actionName,
    error: error,
    info: info,
    deviceInfo: deviceDetect(),
  };
  return JSON.parse(JSON.stringify(payload));
}

export class Logger {
  static info(actionName, screenName, info) {
    splunkLogger.info(createLogEntry(actionName, screenName, 'none', info));
  }

  static error(actionName, screenName, error) {
    splunkLogger.error(createLogEntry(actionName, screenName, error, ''));
  }

  static warn(actionName, screenName) {
    splunkLogger.warn(createLogEntry(actionName, screenName, '', ''));
  }

  static fatal(actionName, screenName) {
    splunkLogger.fatal(createLogEntry(actionName, screenName, '', ''));
  }

  static trace(actionName, screenName) {
    splunkLogger.fatal(createLogEntry(actionName, screenName, '', ''));
  }
}
